// @flow
import * as React from 'react'
import PhoneInput from 'react-phone-number-input/input'

import { Input } from '../atoms/Input'
import BaseField, { type Props as BaseFieldProps } from './BaseField'

type Props = {
  ...BaseFieldProps,
  value: ?string,
  onChange: Function,
  onBlur: Function,
}

function PhoneField({
  value,
  onChange,
  onBlur,
  label,
  ...rest
}: Props): React.Node {
  const formattedValue = React.useMemo(() => {
    if (!value) return ''

    return value.startsWith('+') ? value : `+${value}`
  }, [value])

  return (
    <BaseField semibold label={label} {...rest}>
      <PhoneInput
        {...rest}
        inputComponent={Input}
        maxLength={14}
        onBlur={onBlur}
        onChange={onChange}
        value={formattedValue}
      />
    </BaseField>
  )
}

export default PhoneField
